(function (window, undefined) {
  'use strict';
  angular.module('cbl.telepass.wa').constant('TLPS_CONSTANTS', {
    BASE_ROOT: '/CBL-TELEPASS-WA/app/',
    REST_ROOT: '/CBL-TELEPASS-MF/services/api-',
    REST_CLIENTI_ROOT: '/MSF-PROSPECTMANAGER-MF/api/',
    COMPONENTS_PATH: 'components/',
    SSOREADY_BROADCAST_CODE: 'brio3-run-telepass',
    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        FIELDCONFIGURATOR: 'generale/fieldConfigurator',
      },
      ANAGRAFICA: {
        RECUPERA: 'anagrafica/anagrafica',
      },
      CONTOCORRENTE: {
        RICERCA_CONTICORRENTE: 'contocorrente/conti',
      },
      PRODOTTO: {
        DETTAGLIO_PRODOTTO: 'prodotti/prodotto/',
        CODICE: 'TLPS',
      },
      PRATICA: {
        CREA_PRATICA: 'pratica/pratica',
        SALVA_PRATICA: 'pratica/pratica/',
        PROSEGUI: 'pratica/{idPratica}/avanti',
        INDIETRO: 'pratica/{idPratica}/indietro',
        DETTAGLIO_PRATICA: 'pratica/',
        ANNULLA_PRATICA: 'pratica/pratica/{idPratica}/annulla',
        COMPLETA_PRATICA: 'pratica/completaPratica',
        RIFIUTA_PRATICA: 'pratica/pratica/{idPratica}/rifiuta',
        RISOTTOMETTI_PRATICA: 'pratica/pratica/{idPratica}/risottometti',
      },
      DOMINI: 'dominio/domini/',
      QUESTIONARI: {
        RECUPERA_QUESTIONARI: 'questionari/questionari',
      },
      CONFIGURAZIONI: {
        DOMINI: 'configurazioni/domini/',
        RECUPERA_MODALITA_RITIRO: 'configurazioni/modalitaRitiro',
        VERIFICA_PROMOZIONI: 'configurazioni/verificaPromozioni',
        RECUPERA_OPZIONI_TELEPASS: 'configurazioni/opzione',
      },
      APPROVVIGIONAMENTO: {
        SOGLIE: 'approvvigionamento/soglie',
        AGGIORNA_APPARATO: 'approvvigionamento/ordine/{idOrdine}/riscontro/{codApparato}',
        ORDINI: 'approvvigionamento/ordini',
        ORDINE: 'approvvigionamento/ordine/{idOrdine}',
        APPARATO_PRESA_CARICO: 'approvvigionamento/apparato/presacarico',
        APPARATO_QUANTITA: 'approvvigionamento/apparato/quantita',
        FLUSSO_FILIALE: 'approvvigionamento/apparato/quantita/filiale',
        CHIUDI_FLUSSO: 'approvvigionamento/ordine/{idOrdine}/chiudi',
      },
      POST_VENDITA: {
        RECUPERA_CONTRATTI_CLIENTE: 'postvendita/contratti/',
        REVOCA: 'postvendita/revoca',
        RECUPERA_CARTE_VIACARD: 'postvendita/carteViacard/',
        RESTITUISCI_CARTE: 'postvendita/restituzione',
        AGGIUNGI_CARTE: 'postvendita/aggiunta',
        MODIFICA_CONTO: 'postvendita/modificaIban',
      },
    },
    STATO_PRATICA: {
      IN_CORSO: 'INCORSO',
      CONSOLIDATA: 'CONSOLIDATA',
      PRESENTATA: 'PRESENTATA',
      DAREVISIONARE: 'DAREVISIONARE',
      RIFIUTATA: 'RIFIUTATA',
      VALUTAZIONE: 'VALUTAZIONE',
      ACCETTATA: 'ACCETTATA',
    },
    SPECIALIZZAZIONE_PRATICA: {
      RESTITUZIONE_VIACARD: 'RESTITUZIONE_VIACARD',
      REVOCA_TELEPASS: 'REVOCA_TELEPASS',
      TRASLOCO_TELEPASS: 'TRASLOCO_TELEPASS',
      ALLESTIMENTO_VIACARD: 'PRATICAVIACARD',
      ALLESTIMENTO_TELEPASS: 'PRATICATELEPASS',
      AGGIUNTA_VIACARD: 'AGGIUNTA_VIACARD',
      MODIFICA_CONTO_TELEPASS: 'MODIFICA_CONTO_TELEPASS',
    },
  });
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.constants.js
// module id = 0
// module chunks = 0